import { fetchPricingPlanMap, fetchPricingPlanList, fetchPriceFromZuora } from '@/apis';
import { cachePromise } from '@/utils';

let pricingMapCache = null

export function getPricingMap() {
  if (pricingMapCache) {
    return Promise.resolve(pricingMapCache)
  } else {
    return new Promise((resolve) => {
      fetchPricingPlanMap().then(data => {
        pricingMapCache = data
        resolve(data)
      })
    })
  }
}

export async function getProNode() {
  const priceMap = await getPricingMap()
  return priceMap.pro || {}
}

export const getAllPlanPrice$Cache = cachePromise(async () => {
  const res = await fetchPriceFromZuora()
  return res
})

export const getBasePlan$Cache = cachePromise(async () => {
  const res = await fetchPricingPlanList()
  return res.productList[0]
})
